<template>
  <section>
    <social-header v-if="currentEnv" title="活动列表"></social-header>
    <!-- <share v-if="activities.shareData!=null"
           v-bind:title="activities.shareData.title"
           v-bind:link="activities.shareData.link"
           v-bind:imgUrl="activities.shareData.imgUrl"
    v-bind:desc="activities.shareData.desc"></share>-->
    <!--首页城市选择及个人中心导航-->
    <div class="index-header clearfix">
      <a class="index-city" href="javascript:;" @click="changeCity()" v-stat:click="{ name: 'city' }">
        <span>{{ userCity.cityName }}</span>
        <em class="iconfont_M icon-more_M"></em>
      </a>
      <a class="index-center" href="javascript:;" @click="goAccountPage()" v-stat:click="{ name: 'account' }">
        <em class="icon icon-center"></em>
      </a>
    </div>
    <!--首页城市选择及个人中心导航-->
    <!--首页轮播图-->
    <div class="index-banner" v-if="homeBanner.length > 1">
      <ul>
        <Swiper ref="swiper">
          <Slide v-for="(item, key) in homeBanner" :key="key">
            <li v-stat:click="{
              name: 'banner_' + item.id,
              actid: item.platformId,
            }">
              <a v-bind:href="item.linkUrl">
                <img v-bind:src="item.imageUrl" />
              </a>
            </li>
          </Slide>
        </Swiper>
      </ul>
      <!-- <p class="index-banner-dot"><span  class="current"></span><span></span><span></span></p> -->
    </div>
    <div class="index-banner" v-if="homeBanner.length == 1">
      <ul>
        <li v-for="(item, key) in homeBanner" :key="key"
          v-stat:click="{ name: 'banner_' + item.id, actId: item.platformId }">
          <a v-bind:href="item.linkUrl">
            <img v-bind:src="item.imageUrl" />
          </a>
        </li>
      </ul>
    </div>
    <!--首页轮播图-->
    <!--动态播报-->
    <div class="index-broad" v-if="showRwardScrool === true && rewards.length > 0">
      <div class="index-broad-bottom">
        <img src="../../static/img/index-pic3.png" alt />
        <reward-scroll v-bind:rewardList="rewards"></reward-scroll>
      </div>
    </div>
    <!-- 公告 -->
    <van-sticky>
      <div class="announcement" v-show="isShowNotice">
        <van-notice-bar mode="closeable" color="#ffffff" background="#454545" left-icon="volume-o" scrollable>
          <template #left-icon>
            <img style="width: 1.6rem; height: 1.6rem; margin-right: 0.5rem" src="../../static/img/喇叭.png" alt="" />
          </template>
          <template #right-icon>
            <img style="width: 1.6rem; height: 1.6rem; margin-left: 0.5rem" src="../../static/img/取消.png" alt=""
              @click="closeNotice" />
          </template>
          <span @click="showPopUp">
            为维护市场公平，参与之家活动的推荐官需合规展业，杜绝违规行为！
          </span>
        </van-notice-bar>
      </div>
    </van-sticky>

    <div class="notice" v-show="isShowPopUp">
      <div class="notice-title">
        <img src="../../static/img/感叹号.png" alt="" />
        <span class="notice-title-text">公告</span>
      </div>
      <div class="notice-content">
        <div class="notice-first">
          为维护市场公平，参与之家活动的推荐官需合规展业，杜绝违规行为！
        </div>
        <div class="notice-second">
          <p class="title">违规行为：</p>
          <ul>
            <li>1、与4S店合作拦截客户。</li>
            <li>2、发展非创展推荐官展业。</li>
            <li>3、伪造购车凭证套取佣金或补贴。</li>
            <li>4、以之家名义承诺额外补贴。</li>
          </ul>
        </div>
        <div class="notice-third">
          <p class="title">处罚措施：</p>
          <ul>
            <li>1、取消推广资格。</li>
            <li>2、视情节追回激励。</li>
          </ul>
        </div>
        <div class="notice-forth">请严格遵守，共同维护项目健康发展!!!</div>
      </div>
      <div class="notice-btn" @click="closePopUp()">
        <img src="../../static/img/Button_big_normal.png" alt="" />
      </div>
    </div>
    <div class="mask" v-show="isShowPopUp"></div>
    <!--动态播报-->
    <div class="activity-list">
      <div v-if="isShowHighYield" class="dlr-title white-bg">
        <span>汽车之家活动</span>
      </div>
      <div class="activity-col" v-for="item in activities.activitys" :key="item.id">
        <a href="javascript:;" title>
          <div class="activity-pic" v-debounce="() => handleClick(item.id)">
            <img :src="item.img" alt v-stat:click="{ name: 'activity_detail_pic', actid: item.id }" />
          </div>
          <p class="activity-total" v-if="false">
            本活动累计为用户发放奖励
            <span class="font-red">{{ item.totalReward }}</span>元
          </p>
          <div class="activity-content clearfix">
            <p class="activity-btn" v-debounce="() => btnDetail(item.id)"
              v-stat:click="{ name: 'activity_detail_btn', actid: item.id }">
              查看详情
            </p>
            <div class="activity-text">
              <div class="commission-rules" style="line-height: 1.5rem; font-size: 1rem"
                v-if="item.businessLineId !== 402" v-html="item.commissionRules"></div>
              <div class="commission-rules" style="line-height: 1.5rem; font-size: 1rem"
                v-if="item.businessLineId === 402" v-html="item.commissionRules"></div>
              <p>
                <em class="icon icon-time"></em>
                活动时间{{ item.begin }}-{{ item.end }}
              </p>
            </div>
          </div>
        </a>
      </div>
    </div>
    <!--热推商品榜单-->
    <div class="index-hot">
      <div class="dlr-title" v-show="products.length > 0">
        <span>热销商品榜单</span>
        <router-link :to="{ path: '/products' }" v-stat:click="{ name: 'home_products' }">
          更多
          <em class="iconfont_M icon-more_M"></em>
        </router-link>
      </div>
      <div class="index-hot-con" v-for="(product, index) in products" v-bind:key="index">
        <div class="index-hot-col">
          <router-link :to="{ path: '/product/detail/' + product.id }" v-stat:click="{
            name: 'home_product_detail_wholeArea',
            actid: product.id,
          }" class="clearfix">
            <div class="index-hot-pic">
              <em v-if="index == 0" class="icon icon-first"></em>
              <em v-if="index == 1" class="icon icon-second"></em>
              <em v-if="index == 2" class="icon icon-third"></em>
              <img style="width: 100%" :src="product.img" />
            </div>
            <div class="index-hot-tent">
              <h3>{{ product.name }}</h3>
              <p>售价：¥{{ product.promotionPrice }}元</p>
              <p>
                预计奖励：
                <span>¥{{ product.agentCommission }}元</span>
              </p>
            </div>
          </router-link>
          <router-link :to="{ path: '/product/detail/' + product.id }" v-stat:click="{
            name: 'home_product_detail_btn',
            actid: product.id,
          }" class="index-hot-share" style="letter-spacing: 0">查看详情</router-link>
        </div>
      </div>
    </div>
    <!--热推商品榜单-->
    <social-dialog title="正在加载" category="tips" v-bind:show="dialogShow"></social-dialog>
    <div class="wrapper" v-show="show">
      <div class="block">
        <div class="login">信息补充</div>
        <div class="centent">
          <p>根据业务要求，请补充如下信息以便正常使用产品功能</p>
        </div>
        <div class="UM" v-if="isname">
          <input type="text" placeholder="请输入姓名" v-model="complementUserName" class="input" />
        </div>
        <div class="UM" v-if="iscode">
          <input type="text" placeholder="请输入工号" v-model="complementAgentNo" class="input" />
        </div>
        <div class="submit" @click="submitComp">提交信息</div>
        <img src="../../static/img/小白@3x.png" @click="show = false" class="img" alt="" />
      </div>
    </div>
    <div class="wrapper" v-show="showFile">
      <div class="block">
        <div class="login">温馨提示</div>
        <div class="centent">
          <p>{{ fileMessage }}</p>
        </div>
        <div class="submit" @click="fileClick">我知道了</div>
        <img src="../../static/img/小白@3x.png" @click="showFile = false" class="img" alt="" />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import SocialHeader from "../../components/social-header.vue";
import SocialDialog from "../../components/social-dialog.vue";
import Share from "../../components/share.vue";
import { Swiper, Slide } from "../../components/swiper";
import RewardScroll from "../../components/reward-scroll.vue";
import Tools from "../../tools/tools.js";
import userApi from "../../api/user";
import Dialog from "../../plugins/dialog.js";
import activityApi from "../../api/activity";
import { isGoEnv } from "../../service/vaildGo.service";
import {
  isWeiXin,
  isDingDing,
  changeDocumentTitle,
} from "../../service/environment";
import {
  insidebrowser,
} from "../../environment/mainapp_api.js";

export default {
  components: {
    SocialHeader,
    SocialDialog,
    Share,
    Swiper,
    Slide,
    RewardScroll,
  },

  name: "ActivityHome",
  data: function () {
    return {
      show: false,
      isname: false,
      iscode: false,
      showFile: false,
      fileMessage: "",
      complementAgentNo: "",
      complementUserName: "",
      isLoadingActivity: true,
      isLoadingProduct: false,
      islogin: "未登录",
      testBanner: [
        {
          img: "https://qiniu.epipe.cn/5456575529551388672?imageslim&imageView2/1/w/750/h/360",
        },
        {
          img: "https://qiniu.epipe.cn/5430983074181545984?imageslim&imageView2/1/w/750/h/360",
        },
      ],
      showRwardScrool: true,
      isShowHighYield: true, // go 车隐藏高收益专区文案
      isShowNotice: false,
      isShowPopUp: false
    };
  },
  computed: {
    dialogShow() {
      return this.isLoadingActivity || this.isLoadingProduct;
    },
    cityId() {
      return this.userCity.cityId;
    },
    ...mapGetters({
      activities: "activities",
      userCity: "userCity",
      homeBanner: "homeBanner",
      userInfo: "userInfo",
      rewards: "rewards",
      products: "products",
    }),
    currentEnv() {
      if (isWeiXin()) {
        return false;
      } else if (isDingDing()) {
        return false;
      } else {
        return true;
      }
    },
    entrance() {
      return window.entrance
    }
  },
  methods: {
    async submitComp() {
      const pvAreaId = Tools.getQueryString("pvareaId");
      // 检查是否有未填写的信息
      if (this.isname && this.complementUserName === "") {
        Dialog.toast({ title: "请补充信息" });
        return false;
      }
      if (this.iscode && this.complementAgentNo === "") {
        Dialog.toast({ title: "请补充信息" });
        return false;
      }
      try {
        const res = await userApi.saveComplement({
          pvareaId: pvAreaId,
          complementUserName: this.complementUserName,
          complementAgentNo: this.complementAgentNo,
        });

        if (res.data.returnCode === 0) {
          Dialog.toast({ title: "补传信息成功" });
          this.show = false;
        } else {
          this.fileMessage = res.data.message;
          this.showFile = true;
          this.show = false;
        }
      } catch (error) {
        console.error("提交失败:", error);
        Dialog.toast({ title: "提交失败，请稍后重试！" });
      }
    },
    validateInputLength(input) {
      return /^.{2,30}$/.test(input);
    },
    fileClick() {
      this.showFile = false;
      this.show = true;
    },
    changeCity: function () {
      // 标记用户已经手动切换过城市
      sessionStorage.setItem('hasSwitchedCity', 'true');
      this.$router.push("/province");
    },
    async btnDetail(id) {
      let pvAreaId = Tools.getQueryString("pvareaId");
      const user = this.userInfo;
      let obj = {
        islogin: this.islogin,
        pvareaid: pvAreaId,
        userId: user.platformAgentID,
        activityId: id,
        agentNo: user.agentNo,
        backcard: user.bankStatus,
      };
      Tools.tongji("cf_shhdxq_chakanxiangqing_click", obj, 2);
      if (window.entrance.name == 'mainapp') {
        let href = `${location.href.split('?')[0]}${location.search}#/activity/detail/${id}`
        console.log('---->', href)
        window.location.href = insidebrowser(href, {
          isnotwk: false,
          auto: true,
          clearLoad: true,
          transparentBg: false,
          navigationbarstyle: "0",
          animationtype: "",
          fullScreen: false,
          customshowanimationtype: "",
          disableBack: "",
          loadtype: 0,
          titlecolor: "",
          title: "",
          transparent: true,
          webviewBgcolor: ""
        });
      } else {
        if (!user.agentNo) {
          this.$router.push("/activity/detail/" + id);
        } else {
          let pvAreaId = Tools.getQueryString("pvareaId");
          try {
            let res = await activityApi.getLoginComplete({ pvareaId: pvAreaId });
            this.iscode = false;
            this.isname = false;
            if (res.data.returnCode === 0) {
              if (res.data.result.hasCollection) {
                this.show = true;
                const collectionFields = res.data.result.collectionFields;
                for (const field of collectionFields) {
                  if (field.text === "姓名") {
                    this.isname = true;
                  } else if (field.text === "工号") {
                    this.iscode = true;
                  }
                }
              } else {
                this.$router.push("/activity/detail/" + id);
              }
            } else {
              this.$router.push("/activity/detail/" + id);
            }
          } catch (error) {
            // 处理异步操作失败的情况
            console.error("An error occurred:", error);
          }
        }
      }
    },
    async handleClick(id) {
      const user = this.userInfo;
      if (window.entrance.name == 'mainapp') {
        let href = `${location.href.split('?')[0]}${location.search}#/activity/detail/${id}`
        console.log('---->', href)
        window.location.href = insidebrowser(href, {
          isnotwk: false,
          auto: true,
          clearLoad: true,
          transparentBg: false,
          navigationbarstyle: "0",
          animationtype: "",
          fullScreen: false,
          customshowanimationtype: "",
          disableBack: "",
          loadtype: 0,
          titlecolor: "",
          title: "",
          transparent: true,
          webviewBgcolor: ""
        });
      } else {
        if (!user.agentNo) {
          this.$router.push("/activity/detail/" + id);
        } else {
          let pvAreaId = Tools.getQueryString("pvareaId");
          try {
            let res = await activityApi.getLoginComplete({ pvareaId: pvAreaId });
            this.iscode = false;
            this.isname = false;
            if (res.data.returnCode === 0) {
              if (res.data.result.hasCollection) {
                this.show = true;
                const collectionFields = res.data.result.collectionFields;
                for (const field of collectionFields) {
                  if (field.text === "姓名") {
                    this.isname = true;
                  } else if (field.text === "工号") {
                    this.iscode = true;
                  }
                }
              } else {
                this.$router.push("/activity/detail/" + id);
              }
            } else {
              this.$router.push("/activity/detail/" + id);
            }
          } catch (error) {
            // 处理异步操作失败的情况
            console.error("An error occurred:", error);
          }
        }
      }
    },
    goAccountPage: async function () {
      const user = this.userInfo;
      if (window.entrance.name == 'mainapp') {
        let href = `${location.href.split('?')[0]}${location.search}#/account`
        console.log('---->', href)
        window.location.href = insidebrowser(href, {
          isnotwk: false,
          auto: true,
          clearLoad: true,
          transparentBg: false,
          navigationbarstyle: "0",
          animationtype: "",
          fullScreen: false,
          customshowanimationtype: "",
          disableBack: "",
          loadtype: 0,
          titlecolor: "",
          title: "",
          transparent: true,
          webviewBgcolor: ""
        });
      } else {
        if (!user.agentNo) {
          this.$router.push("/account");
        } else {
          let pvAreaId = Tools.getQueryString("pvareaId");
          try {
            let res = await activityApi.getLoginComplete({ pvareaId: pvAreaId });
            this.iscode = false;
            this.isname = false;
            if (res.data.returnCode === 0) {
              if (res.data.result.hasCollection) {
                this.show = true;
                const collectionFields = res.data.result.collectionFields;
                for (const field of collectionFields) {
                  if (field.text === "姓名") {
                    this.isname = true;
                  } else if (field.text === "工号") {
                    this.iscode = true;
                  }
                }
              } else {
                this.$router.push("/account");
              }
            } else {
              this.$router.push("/account");
            }
          } catch (error) {
            // 处理异步操作失败的情况
            console.error("An error occurred:", error);
          }
        }
      }
    },
    async getLoginCom() {
      let pvAreaId = Tools.getQueryString("pvareaId");
      let res = await activityApi.getLoginComplete({ pvareaId: pvAreaId });
      this.iscode = false;
      this.isname = false;
      if (res.data.returnCode === 0) {
        if (res.data.result.hasCollection) {
          this.show = true;
          const collectionFields = res.data.result.collectionFields;
          for (const field of collectionFields) {
            if (field.text === "姓名") {
              this.isname = true;
            } else if (field.text === "工号") {
              this.iscode = true;
            }
          }
        } else {
          this.$router.push("/account");
        }
      }
    },
    /**
     * 初始化banner啊
     */
    // homeBannerInitialize: function (agentNo, cityId, pvAreaId) {
    //   this.$store.dispatch('InitHomeBanner', { agentNo, cityId, pvAreaId });
    // },
    /**
     * 初始化最新奖励信息
     */
    // homeRewadsInitialize: function (pvAreaId) {
    //   this.$store.dispatch('getRewardList', { pvAreaId });
    // },
    cheackUserAccountState() {
      var self = this;
      if (self.userInfo && self.userInfo.accountState === 2) {
        this.$router.replace("/account");
      }
    },
    showPopUp() {
      this.isShowPopUp = true;
      document.body.style.overflow = "hidden"; // 禁止滚动
    },
    closePopUp() {
      this.isShowPopUp = false;
      document.body.style.overflow = ""; // 允许滚动
      localStorage.setItem("popUpShown", new Date().toISOString()); // 记录当前时间
    },
    showNotice() {
      this.isShowNotice = true;
    },
    closeNotice() {
      this.isShowNotice = false;
      localStorage.setItem("noticeShown", new Date().toISOString()); // 记录当前时间
    },
    resetTimeToMidnight(date) {
      date.setHours(0, 0, 0, 0);
      return date;
    },
    convertToBeijingTime(date) {
      const offset = 8; // 北京时间是UTC+8
      const beijingTime = new Date(
        date.getTime() +
        (offset - date.getTimezoneOffset() / 60) * 60 * 60 * 1000
      );
      return beijingTime;
    },
    checkAndShow(key, showMethod) {
      const lastShown = localStorage.getItem(key);
      if (!lastShown) {
        showMethod(); // 如果没有记录显示时间，则显示弹窗
      } else {
        const lastShownDate = new Date(lastShown);
        const now = new Date();

        const lastShownBeijingMidnight = this.resetTimeToMidnight(
          this.convertToBeijingTime(lastShownDate)
        );
        const nowBeijingMidnight = this.resetTimeToMidnight(
          this.convertToBeijingTime(now)
        );

        if (
          nowBeijingMidnight - lastShownBeijingMidnight >=
          24 * 60 * 60 * 1000
        ) {
          showMethod(); // 如果距离上次显示时间已经过去了一天，则显示弹窗
        }
      }
    },
    // 滚动事件
    scrollHandler() {
      var currentScrollPosition = window.scrollY || window.pageYOffset;
      var navBar = document.getElementsByClassName("announcement")[0];
      navBar.style.top =
        currentScrollPosition > 51 || !this.currentEnv ? "0" : "2.88rem";
      console.log("---->", navBar);
    },
  },
  created: function () {
    if (this.userInfo) {
      this.islogin = "已登录";
    }
    let pvAreaId = Tools.getQueryString("pvareaId");
    let obj = {
      islogin: this.islogin,
      pvareaid: pvAreaId,
      userId: this.userInfo.platformAgentID,
      agentNo: this.userInfo.agentNo,
      backcard: this.userInfo.bankStatus,
    };
    this.cheackUserAccountState();
    changeDocumentTitle("活动列表");
    this.isLoadingActivity = true;
    let cityId;
    if (entrance.name == 'mainapp' || entrance.name == 'WxMini') {
      // 只有首次进入页面（未切换过城市）且 URL 有 cityId 参数时才使用 URL，否则使用 store 中的城市 ID
      let hasSwitchedCity = sessionStorage.getItem('hasSwitchedCity') === 'true';
      cityId = !hasSwitchedCity && Tools.getQueryString("cityId") ? Tools.getQueryString("cityId") : this.$store.getters.userCity.cityId;
    } else {
      cityId = this.$store.getters.userCity.cityId;
    }
    Tools.tongji("cf_shhdxq_chakanxiangqing_show", obj, 1);
    if (!pvAreaId) {
      pvAreaId = "0";
    }
    if (isGoEnv()) {
      this.isShowHighYield = false;
    }
    if (pvAreaId === "2338257") {
      this.showRwardScrool = false;
    }
    activityApi.getLoginComplete({ pvareaId: pvAreaId }).then((res) => {
      this.isname = false;
      this.iscode = false;
      if (res.data.returnCode === 0) {
        if (res.data.result.hasCollection) {
          this.show = true;
          const collectionFields = res.data.result.collectionFields;
          for (const field of collectionFields) {
            if (field.text === "姓名") {
              this.isname = true;
            } else if (field.text === "工号") {
              this.iscode = true;
            }
          }
        }
      }
    });
    let that = this;
    this.$store
      .dispatch("getActivityList", { cityId, pvAreaId, pageSize: 100 })
      .then(function () {
        that.isLoadingActivity = false;
      });

    // that.isLoadingProduct = true;
    // let recommandProductCount = 6;
    // this.$store.dispatch('getProductList', { cityId, pvAreaId, pageSize: recommandProductCount }).then(function () {
    // that.isLoadingProduct = false;
    // });
    /**
     * 处理banner问题
     */
    //     const user = this.userInfo;
    //     if (user.agentNo) {
    //       this.homeBannerInitialize(user.agentNo, cityId, pvAreaId);
    //     }
    //
    //     this.homeRewadsInitialize(pvAreaId);
  },
  watch: {
    userInfo: function (val, oldVal) {
      if (!val) {
        return;
      }
      let pvAreaId = Tools.getQueryString("pvareaId");
      let cityId = this.$store.getters.userCity.cityId;
      if (!cityId) {
        cityId = val.userCityId;
      }
      // this.homeBannerInitialize(val.agentNo, cityId, pvAreaId);
      if (val.accountState === 2) {
        this.$router.replace("/account");
      }
      // 检查上次显示时间
      if (val.uid) {
        this.checkAndShow("popUpShown", this.showPopUp);
        this.checkAndShow("noticeShown", this.showNotice);
      }
    },
  },
};
</script>
<style>
.activity-text .commission-rules p {
  font-size: 1rem;
  color: #000;
  letter-spacing: 1px;
}

.activity-text .commission-rules strong {
  font-weight: bold !important;
}

.activity-text .commission-rules em {
  font-style: italic !important;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.block {
  width: 17.5rem;
  /* height: 19.5rem; */
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 0.75rem;
  border-radius: 0.75rem;
  position: relative;
  padding-bottom: 1.25rem;
}

/* .wrapper::before {
  content: "";

} */
.login {
  font-family: "PingFangSC-Medium";
  font-size: 1.0625rem;
  color: #111e36;
  text-align: center;
  line-height: 1.0625rem;
  margin-top: 2rem;
  font-weight: 600;
}

.img {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 0.75rem;
  height: 0.75rem;
}

.centent {
  width: 15rem;
  height: 2.3125rem;
  font-family: " PingFangSC-Regular";
  font-size: 0.75rem;
  color: #828ca0;
  text-align: justify;
  line-height: 1.125rem;
  margin-top: 1.25rem;
}

.UM {
  width: 17.5rem;
  height: 2.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.75rem;
}

.account {
  font-family: "PingFangSC-Regular";
  font-size: 0.875rem;
  color: #111e36;
  letter-spacing: 0;
  line-height: 1rem;
  padding-left: 1.25rem;
  box-sizing: border-box;
}

.accounts {
  font-family: "PingFangSC-Regular";
  font-size: 0.875rem;
  color: #111e36;
  letter-spacing: 0;
  line-height: 1rem;
  padding-right: 3.6875rem;
  box-sizing: border-box;
}

.input {
  width: 10rem;
  padding-right: 3.125rem;
  margin-left: 1.25rem;
  color: #000;
}

input::placeholder {
  color: #000;
  font-size: 0.875rem;
}

.submit {
  background-image: linear-gradient(270deg, #206cfe 0%, #4c88ff 100%);
  border-radius: 0.1875rem;
  border-radius: 0.1875rem;
  width: 15rem;
  height: 2.5rem;
  font-family: "PingFangSC-Medium";
  font-size: 0.875rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  line-height: 2.5rem;
  margin-top: 1.3125rem;
}

.change {
  margin-top: 0.75rem;
  font-family: "PingFangSC-Regular";
  font-size: 0.8125rem;
  color: #2057ff;
  text-align: center;
  line-height: 1.25rem;
}

.van-notice-bar {
  padding: 0 8px;
}

.notice {
  width: 18.13rem;
  height: 25.97rem;
  position: fixed;
  top: calc(50% - 15.25rem);
  left: calc(50% - 9.06rem);
  z-index: 1000;
  background-image: url("../../static/img/背景图.png");
  background-size: 100% 100%;
  border-radius: 0.75rem;
  box-sizing: border-box;
  padding: 14px 17px 0 17px;
}

.notice .notice-title {
  display: flex;
  width: 100px;
  color: #fff;
  align-items: center;
  margin: 0 auto;
  font-size: 19px;
  margin-bottom: 15px;
}

.notice .notice-title img {
  width: 29px;
  height: 29px;
}

.notice .notice-title .notice-title-text {
  display: inline-block;
  margin-left: 5px;
}

.notice .notice-content .notice-first,
.notice .notice-content .notice-forth {
  font-family: PingFangSC-Medium;
  font-size: 15px;
  line-height: 19px;
  color: #ffe8ad;
  letter-spacing: 0;
  font-weight: 500;
  margin-bottom: 20px;
}

.notice .notice-content .title {
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
  margin-bottom: 5px;
}

.notice .notice-second,
.notice .notice-third {
  margin-bottom: 16px;
}

.notice .notice-content li {
  opacity: 0.75;
  font-family: PingFangSC-Regular;
  font-size: 13px;
  color: #ffffff;
  letter-spacing: 0.5px;
  line-height: 20px;
  font-weight: 400;
}

.notice .notice-content .notice-forth {
  font-size: 14px;
}

.notice .notice-btn {
  width: 240px;
  height: 40px;
  margin: 0 auto;
  margin-top: 25px;
}

.notice .notice-btn img {
  width: 100%;
  height: 100%;
}

.mask {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/home.vue